import { render, staticRenderFns } from "./AlarmListCom.vue?vue&type=template&id=58459e70&scoped=true"
import script from "./AlarmListCom.vue?vue&type=script&lang=js"
export * from "./AlarmListCom.vue?vue&type=script&lang=js"
import style0 from "./AlarmListCom.vue?vue&type=style&index=0&id=58459e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58459e70",
  null
  
)

export default component.exports